import queryString from 'query-string';


export const removeApiKeyFromUrl = (): void => {
    const newUrl = queryString.exclude(window.location.search, ['API_KEY']) || window.location.href.replace(window.location.search, '');
    window.history.replaceState(null, document.title, newUrl);
};
